import React from 'react';
import './banner.css';
import {injectIntl} from "react-intl";

const Banner = () => {
    return (
        <div id="banner">
            <ul>
                <li><p> <b> In case of a new site launch for Stow By Light,</b> please reach out to
                    <a target="_blank" rel="noopener noreferrer" href="https://oncall.corp.amazon.com/#/view/utr-iot-automation/schedule"> iot-automation on-call </a>
                    to enable backend configs.
                </p></li>
                </ul>
        </div>)
}

export  default injectIntl(Banner)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/banner/Banner.js